/*
 * File: InfiniteScroll.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 29, 2025 at 12:36 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';
import { mobileBreakpoint } from '../../styles/constants';


/**
 * Styles
 */

export const MobileContainer = styled.div`
	display: block;

	@media only screen and (max-width: ${mobileBreakpoint}em) {
		display: none;
	}
`;

export const DesktopContainer = styled.div`
	display: none;

	@media only screen and (max-width: ${mobileBreakpoint}em) {
		display: block;
	}
`;

export const PullLoadingIndicator = styled.div`
	width: 100%;
	height: 60px;
	position: relative;
	margin-top: -10px;
`;

export const PullPrompt = styled.div`
	width: 100%;
	padding: 10px 0px;

	p {
		width: 100%;
		color: ${({ theme }) => theme.secondaryText};
		opacity: 0.8;
	}
`;

export const EndContainer = styled.div`
	padding: 30px 0px;

	p {
		color: ${({ theme }) => theme.secondaryText};
	}
`;
